import { AddRounded } from '@mui/icons-material'
import { Chip } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useCreateTimepointSubmission } from '@features/subject/hooks/useCreateTimepointSubmission'
import { SPACING } from '@common/theme/spacing'

export default function AddTimepointSubmissionChip({
  timepointId,
  subjectId,
}: {
  timepointId: string
  subjectId: string
}) {
  const { mutateAsync: createTimepointSubmission } = useCreateTimepointSubmission()
  const { studyId } = useParams<{ studyId: string }>()

  const handleCreateTimepointSubmission = async () => {
    await createTimepointSubmission({
      body: {
        timepoint_id: timepointId,
      },
      path: {
        study_id: studyId!,
        subject_id: subjectId,
      },
    })
  }

  return (
    <Chip
      data-testid="add-timepoint-chip"
      size="small"
      icon={<AddRounded data-testid="add-icon" />}
      sx={{
        backgroundColor: 'status.notStarted',
        display: 'flex',
        alignItems: 'center',
        justifyItems: 'center',
        borderRadius: '8px',
        width: 'auto',
        '& .MuiChip-label': { padding: SPACING.noSpacing },
        paddingY: SPACING.spacingLg,
      }}
      onClick={handleCreateTimepointSubmission}
    ></Chip>
  )
}
